import { render, staticRenderFns } from "./ModificarCodigos.vue?vue&type=template&id=609b56f8&scoped=true&"
import script from "./ModificarCodigos.vue?vue&type=script&lang=js&"
export * from "./ModificarCodigos.vue?vue&type=script&lang=js&"
import style0 from "./ModificarCodigos.vue?vue&type=style&index=0&id=609b56f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609b56f8",
  null
  
)

export default component.exports